import { useTranslations } from '@vocab/react';
import { ButtonLink, IconRocket } from 'braid-design-system';

import { createUpgradeLink } from 'src/App/components/JobActions/links';
import { EVENT_NAME_JOB_UPGRADED_BUTTON_PRESSED } from 'src/App/constants/tracking';
import type { JobListItemFragment } from 'src/graphql/__generated__';
import { useConfig } from 'src/hooks/useConfig';
import { useTracking } from 'src/hooks/useTracking';

import translations from './.vocab';

interface UpgradeButtonProps {
  job: JobListItemFragment;
}

export const UpgradeButton: React.FC<
  React.PropsWithChildren<UpgradeButtonProps>
> = ({ job }) => {
  const { t } = useTranslations(translations);
  const { urlResolver } = useConfig();
  const { trackEvent } = useTracking();

  const upgradeLink = urlResolver({
    path: createUpgradeLink(job),
  });

  const onClick = () => {
    trackEvent(EVENT_NAME_JOB_UPGRADED_BUTTON_PRESSED, {
      jobId: job.id,
    });
  };

  return (
    <ButtonLink
      href={upgradeLink}
      size="small"
      tone="brandAccent"
      onClick={onClick}
      iconPosition="trailing"
      icon={<IconRocket />}
    >
      {t('upgrade')}
    </ButtonLink>
  );
};
